class DVStatusController {
    constructor() {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.isInitialized = true;
            }
        };
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (!changes.row ||
                changes.row.currentValue === changes.row.previousValue) {
                return;
            }
            let row = changes.row.currentValue;
            if (!row) {
                return;
            }
            this.row = row;
            // NOTE: row.DvState only goes up to 2 so we need to
            // work out vm.dvState from the data
            let dvState = this.calcDvState(row);
            this.fileState = dvState;
        };
        this.calcDvState = (row) => {
            let dvState = 'unknown';
            if (row.ProcessCount > 0) {
                // We are either completed or still processing
                dvState = row.Completed !== null ? 'completed'
                    : 'processing';
                return dvState;
            }
            // Otherwise we haven't started yet
            switch (row.DvState) {
                case 1:
                    dvState = 'uploaded';
                    return dvState;
                case 2:
                    dvState = 'submitted';
                    return dvState;
            }
            return dvState;
        };
        this.ago = (dt) => {
            const utc = moment.utc(dt);
            const local = moment(utc).local();
            return moment(local).fromNow();
        };
        this.toNow = (dt) => {
            const utc = moment.utc(dt);
            const local = moment(utc).local();
            return moment(local).fromNow(true);
        };
    }
}
angular.module('app').component('dvStatus', {
    bindings: {
        row: '<' // DataValidatorFileEx
    },
    templateUrl: 'scripts/app/partials/DataValidator/dv-status.tpl.html',
    controllerAs: 'vm',
    controller: DVStatusController
});
